import { Nullable } from '@starsoft/common/interfaces';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UseUserIdentitiesLookUpQueryKeyProps } from './props';
import { UserIdentity } from '@starsoft/common/models';
import { AxiosInstance } from 'axios';

export async function fetchUserIdentitiesLookup(
  { queryKey }: QueryFunctionContext<UseUserIdentitiesLookUpQueryKeyProps>,
  axiosInstance: AxiosInstance,
): Promise<Nullable<UserIdentity>> {
  const { identifier, originId } = queryKey[1];

  const response = await axiosInstance.get<Nullable<UserIdentity>>(
    '/user-identities/lookup',
    {
      params: {
        identifier,
        originId,
      },
    },
  );
  return response.data;
}
